import { createCompositeFooterMainSection } from "./elements/main-section/index.js";
import { createCompositeFooterUtilitySection } from "./elements/utility-section/index.js";
import { createCompositeFooterBase } from "./base.js";
const CreateFooterMegaElement = (props) => {
  const main = createCompositeFooterMainSection(props);
  const utility = createCompositeFooterUtilitySection(props);
  return createCompositeFooterBase(props, [main, utility]);
};
const createCompositeFooterMega = CreateFooterMegaElement;
export {
  createCompositeFooterMega
};
//# sourceMappingURL=mega.js.map
